import ApiClient from './ApiClient'
import { withQuery } from '../../utils/urlParams'

const alertsBase = collectId => `/collects/${collectId}/alerts`

// Snake_case keys for the alerts_preferences JSONB payload exchanged with
// Rails. Kept as constants so the translation to camelCase happens once.
const PRIMARY_COLUMNS_KEY = 'primary_columns'
const QUESTION_IDS_KEY = 'question_ids'
const VARIABLE_IDS_KEY = 'variable_ids'

// Snake_case keys for the alert create payload (Rails alert_params).
const USER_IDS_KEY = 'user_ids'
const RESOURCE_USERS_ROLES_KEY = 'resource_users_roles'
const LAST_USER_PERFORMING_CONTROL_KEY = 'last_user_performing_control'
// Per-field validation errors key from the NestedFormValidator response contract.
const FORMATTED_ERRORS_KEY = 'formatted_errors'

const pickArray = (source, key, fallback) =>
  Array.isArray(source?.[key]) ? source[key] : fallback

class AlertsService {
  static getAlerts(collectId, params = {}) {
    const pageParams = [
      ['page', params.page],
      ['limit', params.items],
      ['q', params.q]
    ]
    return ApiClient.get(withQuery(`${alertsBase(collectId)}.json`, pageParams))
  }

  static createAlert(collectId, { name, userIds, resourceRoles, lastUserPerformingControl }) {
    const alert = { name }
    alert[USER_IDS_KEY] = userIds
    alert[RESOURCE_USERS_ROLES_KEY] = resourceRoles
    alert[LAST_USER_PERFORMING_CONTROL_KEY] = lastUserPerformingControl
    return ApiClient.post(`${alertsBase(collectId)}.json`, { alert }).then(data => ({
      success: data.success,
      id: data.id,
      formattedErrors: data[FORMATTED_ERRORS_KEY] || {}
    }))
  }

  static transformPreferences(apiPreferences, defaults) {
    if (!apiPreferences)
      return { ...defaults }
    return {
      primaryColumns: pickArray(apiPreferences, PRIMARY_COLUMNS_KEY, defaults.primaryColumns),
      questionIds: pickArray(apiPreferences, QUESTION_IDS_KEY, defaults.questionIds),
      variableIds: pickArray(apiPreferences, VARIABLE_IDS_KEY, defaults.variableIds)
    }
  }

  static savePreferences(collectId, preferences) {
    const payload = {}
    payload[PRIMARY_COLUMNS_KEY] = preferences.primaryColumns
    payload[QUESTION_IDS_KEY] = preferences.questionIds
    payload[VARIABLE_IDS_KEY] = preferences.variableIds
    return ApiClient.post(`/collects/${collectId}/alerts_preferences.json`, { preferences: payload })
  }

  static duplicateAlert(collectId, alertId) {
    return ApiClient.post(`${alertsBase(collectId)}/${alertId}/duplicate.json`, {})
  }

  static destroyAlert(collectId, alertId) {
    return ApiClient.delete(`${alertsBase(collectId)}/${alertId}.json`)
  }
}

export default AlertsService
